/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface UsersCentresLiesSearch
 */
export interface UsersCentresLiesSearch {
    /**
     * 
     * @type {number}
     * @memberof UsersCentresLiesSearch
     */
    idUser?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof UsersCentresLiesSearch
     */
    selectedIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UsersCentresLiesSearch
     */
    availableIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UsersCentresLiesSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof UsersCentresLiesSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof UsersCentresLiesSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UsersCentresLiesSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof UsersCentresLiesSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof UsersCentresLiesSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the UsersCentresLiesSearch interface.
 */
export function instanceOfUsersCentresLiesSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UsersCentresLiesSearchFromJSON(json: any): UsersCentresLiesSearch {
    return UsersCentresLiesSearchFromJSONTyped(json, false);
}

export function UsersCentresLiesSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsersCentresLiesSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idUser': !exists(json, 'idUser') ? undefined : json['idUser'],
        'selectedIds': !exists(json, 'selectedIds') ? undefined : json['selectedIds'],
        'availableIds': !exists(json, 'availableIds') ? undefined : json['availableIds'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function UsersCentresLiesSearchToJSON(value?: UsersCentresLiesSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idUser': value.idUser,
        'selectedIds': value.selectedIds,
        'availableIds': value.availableIds,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

